<template>
 <div class="page-box">
  <div class="page-con">
  <div class="plr16">
  欢迎访问管理后台
  </div>
  </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex"
  import { message } from 'ant-design-vue'
  
 // import {setTimeout,setInterval,clearTimeout,clearInterval}  from 'timers'
  export default {
    name: "home",
    data() {
      return {
   

      }
    },
    created() {
    

    }, 
    
    methods: {
      

      

    }


  };

 




</script>

<style scoped>

</style>
